import Session from '@/components/Session';

import Icon_21 from '@/assets/images/icon_21.svg';
import Icon_22 from '@/assets/images/icon_22.svg';
import Icon_23 from '@/assets/images/icon_23.svg';

export default function Who({ detail }) {
    return (
        <>
            <Session className='who'>
                <div className='title'>{detail?.label?.who?.title || 'Who We Serve?'}</div>
                <div className='items'>
                    <div className='item'>
                        <div className='pic'>
                            <img
                                className='bg'
                                style={{
                                    backgroundImage: `url(${detail?.label?.who?.items?.[0]?.pic || 'https://ak-d.tripcdn.com/images/0a10z120009sonv0t7991.png'})`,
                                }}
                                src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAAyCAQAAACgo97bAAAANUlEQVR42u3OQREAAAwCoNm/9Fp4PiABuRlRUVFRUVFRUVFRUVFRUVFRUVFRUVFRUVFRUel4z40AM/aPwzQAAAAASUVORK5CYII='
                            />
                        </div>
                        <div className='icons'>
                            <img
                                className='icon'
                                src={Icon_21.src}
                            />
                        </div>
                        <div className='box'>
                            <div className='title'>{detail?.label?.who?.items?.[0]?.title || 'Business Purpose'}</div>
                            <div
                                className='desc'
                                dangerouslySetInnerHTML={{
                                    __html: detail?.label?.who?.items?.[0]?.desc || 'Corporate travelers<br />Short-term job assignments',
                                }}
                            />
                        </div>
                    </div>

                    <div className='item'>
                        <div className='pic'>
                            <img
                                className='bg'
                                style={{
                                    backgroundImage: `url(${detail?.label?.who?.items?.[1]?.pic || 'https://ak-d.tripcdn.com/images/0a15j120009sooo8l7860.png'})`,
                                }}
                                src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAAyCAQAAACgo97bAAAANUlEQVR42u3OQREAAAwCoNm/9Fp4PiABuRlRUVFRUVFRUVFRUVFRUVFRUVFRUVFRUVFRUel4z40AM/aPwzQAAAAASUVORK5CYII='
                            />
                        </div>
                        <div className='icons'>
                            <img
                                className='icon'
                                src={Icon_22.src}
                            />
                        </div>
                        <div className='box'>
                            <div className='title'>{detail?.label?.who?.items?.[1]?.title || 'New City Dwellers'}</div>
                            <div
                                className='desc'
                                dangerouslySetInnerHTML={{
                                    __html: detail?.label?.who?.items?.[1]?.desc || 'International students<br />Moving to a new city for work',
                                }}
                            />
                        </div>
                    </div>

                    <div className='item'>
                        <div className='pic'>
                            <img
                                className='bg'
                                style={{
                                    backgroundImage: `url(${detail?.label?.who?.items?.[2]?.pic || 'https://ak-d.tripcdn.com/images/0a16i120009soo3v69C63.png'})`,
                                }}
                                src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAAyCAQAAACgo97bAAAANUlEQVR42u3OQREAAAwCoNm/9Fp4PiABuRlRUVFRUVFRUVFRUVFRUVFRUVFRUVFRUVFRUel4z40AM/aPwzQAAAAASUVORK5CYII='
                            />
                        </div>
                        <div className='icons'>
                            <img
                                className='icon'
                                src={Icon_23.src}
                            />
                        </div>
                        <div className='box'>
                            <div className='title'>{detail?.label?.who?.items?.[2]?.title || 'Other Categories'}</div>
                            <div
                                className='desc'
                                dangerouslySetInnerHTML={{
                                    __html: detail?.label?.who?.items?.[2]?.desc || 'House renovation<br />Digital nomads<br />Extended vacationers',
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Session>
        </>
    );
}
